import { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import { Button } from 'reactstrap';
import { FaDownload, FaSlack } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  EmailInvite,
  getInviteLink,
  getProjects,
  getTeams,
  upLoadBulk,
} from '../../../../redux/MainAction';
import { toast } from 'react-toastify';
import { getBaseUrl, getInviteRegisterUrl } from '../../../../Constant';

const AddEditMembers = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const tmlist = useSelector((state) => state.Webtracker.teams);

  const link = useSelector((state) => state.Webtracker?.inviteLink);
  const projList = useSelector((state) => state?.Webtracker?.projects);

  const [inviteEmail, setInviteEmail] = useState([
    { email: '', role: 'EMPLOYEE', teamIds: '', projectId: '' },
  ]);

  const [switch2, setSwitch2] = useState(true);

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');

  useEffect(() => {
    if (!link || !link?.joiningToken) dispatch(getInviteLink());
  }, [link?.joiningToken]);

  useEffect(() => {
    if (!projList || !Array.isArray(projList?.rows)) {
      var data = {
        offset: 0,
        limit: 10,
      };
      dispatch(getProjects(data));
    }
  }, [projList]);

  const handleSwitchChange = () => {
    setSwitch2(!switch2);
  };

  const addEmailInvite = () => {
    setInviteEmail([
      ...inviteEmail,
      { email: '', role: '', teamIds: '', projectId: '' },
    ]);
  };
  const removeEmail = (index) => {
    const filterDiet = [...inviteEmail];
    filterDiet.splice(index, 1);
    setInviteEmail(filterDiet);
  };
  const onChangeAddEmail = (e, index) => {
    const { name, value } = e.target;
    const list = [...inviteEmail];
    list[index][name] = value;
    setInviteEmail(list);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && /\.(csv|xlsx|xlsv)$/i.test(file.name)) {
      setSelectedFile(file);
      setUploadStatus('');
    } else {
      setUploadStatus(
        'Invalid file type. Please upload a CSV, XLSX, or XLSV file.'
      );
    }
  };

  const onSubmitEmail = async (e) => {
    e.preventDefault();

    const invalidEntries = inviteEmail.filter((item) => !item.email);

    if (invalidEntries.length > 0) {
      toast.error('Email is mandatory for all records!');
      return;
    }

    const transformedData = inviteEmail.map((item) => {
      const newItem = { email: item.email, role: item.role };
      if (item.teamIds) {
        newItem.teamIds = [item.teamIds];
      }
      if (item.projectId) {
        newItem.projectId = [item.projectId];
      }
      return newItem;
    });

    const payload = {
      members: transformedData,
    };

    await dispatch(EmailInvite(payload));
    onClose();
  };

  const handleCopy = () => {
    const linkValue = `${getInviteRegisterUrl()}/${link?.joiningToken}`;
    navigator.clipboard
      .writeText(linkValue)
      .then(() => {
        alert('Link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy the text: ', err);
      });
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error('No file selected.!');
      return false;
    }
    const formData = new FormData();
    formData.append('file', selectedFile);

    await dispatch(upLoadBulk(formData));
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal4' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5>Invite Members</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>

      <ul className=" nav nav-tabs nav-tabs-custom " role="tablist">
        <li className="nav-item ">
          <a
            className="nav-link active"
            data-toggle="tab"
            href="#project1"
            role="tab"
          >
            <span className="d-none d-md-block ">By Email</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-home-variant h5"></i>
            </span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-toggle="tab" href="#members2" role="tab">
            <span className="d-none d-md-block">Bulk Invite</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-account h5"></i>
            </span>
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            data-toggle="tab"
            href="#properties3"
            role="tab"
          >
            <span className="d-none d-md-block">Copy Link</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-email h5"></i>
            </span>
          </a>
        </li>
        {/* <li className="nav-item">
          <a
            className="nav-link"
            data-toggle="tab"
            href="#properties_4"
            role="tab"
          >
            <span className="d-none d-md-block">By Integration</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-email h5"></i>
            </span>
          </a>
        </li> */}
      </ul>

      <div className="tab-content">
        <div className="tab-pane active p-3" id="project1" role="tabpanel">
          {inviteEmail?.map((eml, idx) => (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ gap: '10px' }}
            >
              <div className="form-group">
                <label className="text-muted" for="name">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  id="name"
                  placeholder="Enter email"
                  onChange={(e) => onChangeAddEmail(e, idx)}
                  value={eml?.email}
                />
              </div>
              <div className="form-group">
                <label className="text-muted">Member Type </label>
                <div className="">
                  <select
                    className="form-control"
                    name="role"
                    onChange={(e) => onChangeAddEmail(e, idx)}
                    value={eml?.role}
                  >
                    <option value="">members type</option>
                    <option value="TEAM-MANAGER">Team Manager</option>
                    <option value="PROJECT-MANAGER">Project Manager</option>
                    <option value="EMPLOYEE">Employee</option>
                    <option value="EXECUTIVE-MANAGER">Executive Manager</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="text-muted">Team (Optional)</label>
                <div className="">
                  <select
                    className="form-control"
                    name="teamIds"
                    onChange={(e) => onChangeAddEmail(e, idx)}
                    value={eml?.teamIds}
                  >
                    <option>Select team</option>
                    {tmlist?.rows?.map((itm, idx) => (
                      <option key={idx} value={itm?.id}>
                        {itm?.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="text-muted">Project(Optional)</label>
                <div className="">
                  <select
                    className="form-control"
                    name="projectId"
                    onChange={(e) => onChangeAddEmail(e, idx)}
                    value={eml?.projectId}
                  >
                    <option>Select Project </option>
                    {projList?.rows?.map((itm, idx) => (
                      <option key={idx} value={itm?.id}>
                        {itm?.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <i
                className="fa fa-trash text-danger"
                onClick={() => removeEmail(idx)}
              ></i>
            </div>
          ))}
          <div className="mb-1">
            <Button outline size="sm" color="primary" onClick={addEmailInvite}>
              Add Email
            </Button>
          </div>
          <div className="modal-footer">
            {/* <button type="button" className="btn btn-light" onClick={onClose} >Cancel</button> */}
            <button
              type="button"
              className="btn btn-dark"
              onClick={onSubmitEmail}
            >
              Invite
            </button>
          </div>
        </div>
        <div className="tab-pane p-3" id="members2" role="tabpanel">
          <div>
            <span className="d-flex align-items-center justify-content-between gap-2">
              Upload CSV, XLSX, or XLSV files by following our template format.
              <a
                href={`${getBaseUrl()}/public/sample-files/bulk-invitation-template.csv`}
                className="btn btn-link border"
                download
              >
                Sample <FaDownload style={{ marginLeft: '10px' }} />
              </a>
            </span>
            <input
              type="file"
              accept=".csv,.xlsx,.xlsv"
              className="form-control mt-4"
              onChange={handleFileChange}
            />
          </div>
          <div className="modal-footer p-0 pt-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpload}
            >
              Save
            </button>
          </div>
        </div>
        <div className="tab-pane p-3" id="properties3" role="tabpanel">
          <div>
            <span>Copy the link to this workspace and send to members:</span>
            <div className="d-flex mt-3" style={{ gap: '10px' }}>
              <input
                type="text"
                value={`${getInviteRegisterUrl()}/${link?.joiningToken}`}
                className="form-control"
                readOnly
              />
              <Button
                size="sm"
                color="dark"
                style={{ width: '120px' }}
                onClick={handleCopy}
              >
                <i className="mdi mdi-content-copy"></i> Copy
              </Button>
            </div>
          </div>
        </div>
        <div className="tab-pane p-3" id="properties_4" role="tabpanel">
          <div>
            <span>Import members from :</span>
            <div className="d-flex mt-3">
              <Button outline size="sm" color="dark" style={{ width: '200px' }}>
                <FaSlack /> Slack
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddEditMembers;
